import type { ICourseExamStatesResponse } from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";

const getApis = createGetApi<
  IApiResponse<ICourseExamStatesResponse>,
  IPathBaseParam,
  object
>("courses.exams.states");

export const states = {
  ...getApis,
};
